export const MAP_PRESENTATIONAL_SET_VIEW = 'MAP_PRESENTATIONAL/SET_VIEW';
export const MAP_PRESENTATIONAL_SET_SHOW_WRONG_PASSWORD_ERROR = 'MAP_PRESENTATIONAL/SET_SHOW_WRONG_PASSWORD_ERROR';
export const MAP_PRESENTATIONAL_SET_SHOW_PRESENTATIONAL_MENU = 'MAP_PRESENTATIONAL/SET_SHOW_PRESENTATIONAL_MENU';
